import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { RewardPoints } from '@frontend/sports/types/models/loyalty';
import { Observable, catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RewardPointsService {
    private readonly api = inject(ApiService);
    private readonly loggerFactory = inject(LoggerFactory);
    private readonly logger = this.loggerFactory.getLogger('RewardPointsService');

    getRewardPoints(): Observable<RewardPoints | undefined> {
        return this.api.get<RewardPoints>('mybets/getRewardPoints').pipe(
            catchError((err) => {
                this.logger.error(err, 'Error while fetching rewardPoints');

                return of(undefined);
            }),
        );
    }
}
